import { Link } from 'react-router-dom'
import { formatCurrency, formatDate } from '../../../tools/format'
import { ReactComponent as CopyIcon } from './copy-text.svg'

const columns = [
  {
    name: 'Image',
    sortable: false,
    selector: row => <img src={row.imageUrl} className="table-image" alt="car" />,
  },
  {
    name: 'Car',
    sortable: true,
    grow: 2,
    selector: row => (
      <div>
        <div>
          <b>{row.year} {row.make} {row.model}</b>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          Lot:{' '}
          <a target="_blank" rel="noreferrer" href={row.detailedUrl}>
            #{row.lotNumber}
          </a>
          <div style={{ width: 4 }}>{' '}</div>
          <button type='button' className='btn' style={{ fontSize: 13, padding: 0, borderRadius: 2, width: 16 }} onClick={() => { navigator.clipboard.writeText(row.lotNumber) }}><CopyIcon /></button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          VIN: {row.vin}
          <div style={{ width: 4 }}>{' '}</div>
          <button type='button' className='btn' style={{ fontSize: 13, padding: 0, borderRadius: 2, width: 16 }} onClick={() => { navigator.clipboard.writeText(row.vin) }}><CopyIcon /></button>
        </div>
      </div>
    ),
  },
  {
    name: 'Winner',
    sortable: true,
    selector: row => {
      const userLink = row.userName ? <Link to={`/users/${row.userName}`}>{row.userName}</Link> : null;
      const buyerLink = row.buyerNumber ? <Link to='/accounts'>{row.buyerNumber}</Link> : null;

      return (
        <div>
          <div>User: {userLink ?? 'N/A'}</div>
          <div>Buyer: {buyerLink}</div>
        </div>
      )
    }
  },
  {
    name: 'Location',
    sortable: true,
    selector: row => row.location,
  },
  {
    name: 'Auction',
    sortable: true,
    selector: row => row.auction,
  },

]

export const lotsColumns = [
  ...columns,
  {
    name: 'Sale Date',
    sortable: true,
    selector: row => row.saleDate && formatDate(row.saleDate),
  },
  {
    name: 'Bid',
    sortable: true,
    selector: row => (
      <div>
        <div>Current Bid: {formatCurrency(row.currentBid)}</div>
        {row.myMaxBid && <div>My Max Bid: {formatCurrency(row.myMaxBid)}</div>}
        <div>Status: {row.counterBidStatus !== 'DEFAULT' ? row.counterBidStatus : row.memberBidStatus}</div>
      </div>
    ),
  },
]

export const invoicesColumns = [
  ...columns,
  {
    name: 'Invoice Date',
    sortable: true,
    selector: row => formatDate(new Date(row.invoiceDate)),
  },
  {
    name: 'Price',
    sortable: true,
    grow: 2,
    selector: row => (
      <div>
        <div>
          Total Amount:{' '}
          <a target="_blank" rel="noreferrer" href={`/uploads/${row.lotNumber}.pdf`}>
            {formatCurrency(row.totalAmount)}
          </a>
        </div>
        <div>High Bid Price: {formatCurrency(row.highBidPrice)}</div>
        {row.memberPaidDate && <div>Paid Date: {formatDate(row.memberPaidDate)}</div>}
      </div>
    ),
  },
]
